import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../_services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatasearchService } from '../../_services/datasearch.service';
import { BusyService } from '../../_services/busy.service';
import { DatePipe, NgClass, NgFor, NgIf, UpperCasePipe } from '@angular/common';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';

@Component({
  selector: 'app-news-categories',
  standalone: true,
  imports: [
    NgFor, DatePipe, UpperCasePipe, NgIf, FooterComponent, HeaderComponent, SidebarComponent, NgClass
  ],
  templateUrl: './news-categories.component.html',
  styleUrls: ['./news-categories.component.scss']
})
export class NewsCategoriesComponent implements OnInit {

  categories: any[] = [];
  filePath = 'https://adminbackend.chemrobotics.com/uploads/news_images/';
  databaseName = 'AgroPat Discovery'; // Default to AgroPat Discovery database for this suite
  heading = '';
  toggle_sidebar = false;

  constructor(
    private globalService: GlobalService,
    private route: ActivatedRoute,
    private busyService: BusyService,
    private datasearch: DatasearchService,
    private router: Router
  ) { }

  ngOnInit() {
    this.globalService.sendMenuIndex(1); // Set to Discovery Updates index
    
    // Get database name from query params if available
    this.route.queryParams.subscribe(params => {
      if (params['databaseName']) {
        this.databaseName = params['databaseName'];
      }
    });

    this.loadCategories();
  }

  receiveHeading(event: string) {
    this.heading = event;
  }

  receiveSidebarEvent(event: boolean) {
    this.toggle_sidebar = event;
  }

  loadCategories() {
    this.busyService.busy();

    // Fetch categories for SPC database
    this.datasearch.getDatabaseCategories(this.databaseName).subscribe({
      next: (res: any) => {
        this.busyService.idle();

        const categoriesData = res?.data?.categories || [];
        console.log('✅ Categories from API:', categoriesData);

        if (!categoriesData.length) {
          console.warn('⚠️ No categories found for database:', this.databaseName);
          return;
        }

        // Store categories with subcategories
        this.categories = categoriesData.map((cat: any) => ({
          _id: cat._id,
          name: cat.name,
          description: cat.description,
          subcategories: cat.subcategories || [],
          expanded: false // For UI toggle
        }));

        console.log('📂 Processed Categories:', this.categories);
      },
      error: (err: any) => {
        this.busyService.idle();
        console.error('❌ Error fetching categories:', err);
      }
    });
  }

  toggleCategory(category: any) {
    category.expanded = !category.expanded;
  }

  goToCategoryNews(categoryId: string) {
    this.router.navigate(['/discovery-category', categoryId]);
  }

  goToSubcategoryNews(subcategoryId: string) {
    this.router.navigate(['/discovery-category', subcategoryId]);
  }

  navigateBack(): void {
    this.router.navigate(['/discovery']);
  }
}
